"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var DropdownContext = /*#__PURE__*/_react["default"].createContext(null);

var _default = DropdownContext;
exports["default"] = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../~/react-overlays/cjs/DropdownContext.js
// module id = 693
// module chunks = 0